import { Layout } from 'antd';
import { useContext , useEffect} from "react"; 
import NavBar from "../../components/NavBar";
import ManualTestDetail from "../../components/test/ManualTestDetail";

const { Content } = Layout;

function ManualTest() {
   return (
      <Layout className="container main-layout">
            <NavBar />
         <Layout className="bg-gray">
            <Content className="layout-content">
               <ManualTestDetail />
            </Content>
         </Layout>
      </Layout>
   );
}

export default ManualTest;
